<div class="google-sso-config-dialog">
    <div class="title" mat-dialog-title>Google SSO Setup Complete</div>
    <div class="dialog-body">
        <div class="success-message">
            <mat-icon class="success-icon">check_circle</mat-icon>
            <p>Google SSO is setup successfully, it may take up to 15 mins to get ready.</p>
        </div>

        <p class="instructions">Please share the login URL with your users:</p>

        <div class="steps-container">
            <div class="step">
                <div class="step-header">
                    <span class="step-number">1</span>
                    <span class="step-title">Contact Rubii Support</span>
                </div>
                <div class="step-content">
                    <p>Please contact Rubii support to add the following redirect URL to the Google OAuth client:</p>
                    <div class="url-box">
                        <code>https://{{payload.shortname}}.sso.{{domain}}/oauth2/idpresponse</code>
                    </div>
                    <p class="step-info">This step must be completed before users can login via Google SSO.</p>
                </div>
            </div>
            <div class="step">
                <div class="step-header">
                    <span class="step-number">2</span>
                    <span class="step-title">Share Login URL with Users</span>
                </div>
                <div class="step-content">
                    <p>Share the login URL below with your users to enable SSO login:</p>
                    <div class="url-box">
                        <code>https://{{payload.shortname}}.{{domain}}</code>
                    </div>
                    <p class="step-info">All users can use this URL to login via Google SSO.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button mat-raised-button color="primary" [mat-dialog-close]="true">Done</button>
    </div>
</div>
